<template>
  <!-- 讲堂、视频 -->
  <div class="module-class" ref="moduleClass">
    <div class="m-home-swiper">
      <div style="text-align:center">
        <!-- <img class="img-title" src="../../assets/images/home/pic_title5@2x.png" alt="" /> -->
      </div>

      <div class="swiper-box">
        <div class="swiper-container swiper-class-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide g-pointer" v-for="(item, index) in dataList" @click="goDetail(item)" :key="index">
              <div class="pic-box">
                <img v-lazy="item.pic" alt="">
                <div class="icon-play" v-if="busType === '2'"></div>
              </div>
              <!-- 讲堂 -->
              <div class="info" v-if="busType === '1'">
                <div class="title mb-20">
                  <h2 class="ell m-font-2 pf-regular">{{item.title}}</h2>
                  <!-- <span class="tag">线上直播? ｜ 免费</span> -->
                </div>
                <div class="time-box pf-regular m-font-6">
                  <p class="time">
                    <img src="~@images/icon_time.png" alt=""> 
                    {{item.time}}
                  </p>
                  <p class="desc ell">
                    <img src="~@images/icon_loc.png" alt=""> 
                    <span class="ell">{{item.address}}</span>
                  </p>
                </div>
              </div>

              <!-- 视频资源 -->
              <div class="info info-video" v-if="busType === '2'">
                <!-- <div class="time-box mb-10">
                  <p>
                    <img src="~@images/icon_triangle.png" alt=""> 
                    宣传
                  </p>
                </div> -->
                <h2 class="ell pf-regular m-font-2">{{item.title}}</h2>
              </div>
            </div>
          </div>
          <!-- <div class="swiper-button-prev swiper-button-white"></div>
          <div class="swiper-button-next swiper-button-black"></div> -->

          <!-- <div class="swiper-pagination swiper-pagination-class"></div> -->
        </div>
      </div>
    </div>

    <cmpVideo ref="cmpVideo"></cmpVideo>
  </div>
</template>

<script>
import cmpVideo from '@cmp/video'
export default {
  components: { cmpVideo },
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      }
    },
    busType: {
      type: String,
      default: '1'  // 1辽博讲堂 2视频资源
    },
    eleClass: {
      type: String,
      default: ''
    }
  },
  watch: {
    dataList: {
      handler() {
        setTimeout(() => {
          this.initSwiper()
        }, 500)
      },
      immediate: true
    }
  },

  data() {
    return {}
  },

  methods: {
    initSwiper() {
      this.$nextTick(() => {
        let swiper = new Swiper(this.eleClass + " .module-class .swiper-container.swiper-class-container", {
          // loop: true,
          // loopAdditionalSlides: 2,
          // autoplay: 5000,
          // slidesPerView: 1,
          // spaceBetween: 20,
          observer: true,
          observeParents: true,
          // prevButton: this.eleClass + ' .module-class .swiper-button-prev',
          // nextButton: this.eleClass + ' .module-class .swiper-button-next',
          // pagination: '.module-class .swiper-pagination-class',
          // paginationClickable: true,
          autoplayDisableOnInteraction: false, // 用户操作 swiper 之后自动切换不会停止
        })
      })
    },

    // getDataList() {
    //   this.listLoading = true
    //   this.$http
    //     .get('/public/index.do', {
    //       ...this.listQuery
    //     })
    //     .then(res => {
    //       this.listLoading = false
    //       if (res.success) {
    //         this.redList = res.data.Carousels
    //         this.initSwiper()
    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     })
    // },

    goDetail(item) {
      if(this.busType === '1') {
        this.$router.push({
          path: '/research/detail',
          query: { id: item.id, pageType: '5' }
        })
      } else {
        this.$refs.cmpVideo.init(item)
        // window.open(item.url)
        // this.$router.push({
        //   path: '/video/detail',
        //   query: { id: item.id }
        // })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.module-class {
  .swiper-container {
    position: relative;
    // width: 600px;
    width: 100%;
    // height: 400px;
    overflow: hidden;
    .swiper-slide {
      position: relative;
      width: 100%;
      // height: 400px;
      // background-image: url(~@images/home/banner.jpg);
      // // background-position: center top;
      // background-position: center center;
      // background-repeat: no-repeat;
      // background-size: cover;
      .pic-box {
        position: relative;
        overflow: hidden;
        img {
          width: 100%;
          // height: 100%;
          height: 440px;
          object-fit: cover;
          transition: all 0.6s;
        }
        .icon-play {
          width: 97px;
          height: 97px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          background: url(~@images/icon-play.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
      &:hover {
        .pic-box {
          img {
            transform: scale(1.02);
          }
        }
      }
      
      .info {
        z-index: 2;
        padding: 20px 0;
        color: #000;
        h2 {
          // font-size: 24px;
          // font-weight: bold;
        }
        .title {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          h2 {
            flex: 1;
          }
          .tag {
            padding-right: 10px;
            font-size: 18px;
            color: rgba($color: #303030, $alpha: 0.7);
            width: 170px;
            text-align: right;
          }
        }
        .time-box {
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          .time {
            width: 260px;
          }
          .desc {
            // margin-left:10px;
            flex: 1;
          }
          p {
            display: flex;
            align-items: center;
            img {
              width: 22px;
              height: 22px;
              height: auto;
              margin-right: 5px;
              margin-top: 2px;
            }
          }
        }
      }
    }

    .swiper-button-next, 
    .swiper-button-prev {
      top: 38%;
    }
    .swiper-button-prev {
      display: none;
    }

    // image.active {
    //   transform:none;
    //   transition:all 0.2s ease-in0s;
    // }
    
    // image.quiet {
    //   transform: scale(0.8333333);
    //   transition:all 0.2s ease-in0s;
    // }

    // /deep/ .swiper-pagination-bullet-active {
    //   background: #fff;
    // }

    /deep/ .swiper-pagination {
      bottom: 60px;
      left: 170px;
    }
  }
}
</style>